import { createSingleAction } from 'store/utils';

export const SET_SUBMITTING_ORG_FILTER = 'settings/submittingOrgs/SET_SUBMITTING_ORG_FILTER';
export const setSubmittingOrgFilter = createSingleAction<string, typeof SET_SUBMITTING_ORG_FILTER>(
    SET_SUBMITTING_ORG_FILTER,
);
